// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar_bar__3Tp35","barHolder":"ProgressBar_barHolder__ZM7a+","barLen":"ProgressBar_barLen__I49X+"};